import { lazy } from 'react';

const BillingProfilesList = lazy(() =>  import('../pages/BillingProfiles/List'));
const BillingProfilesDetail = lazy(() =>  import('../pages/BillingProfiles/Detail'));

export default [{
    path: "/billingprofiles",
    element: BillingProfilesList,
    analytics: { name: ["Profili di fatturazione"]}
}, {
    path: "/billingprofiles/:billingprofileId",
    element: BillingProfilesDetail,
    analytics: { name: ["Profili di fatturazione", "Dettaglio"]},
}]
